import React from 'react';
import { Alert, Spin, Typography } from 'antd';
import { useModalWatch } from '../../../shared/packages/modalManager';
import { modalNames } from '../../../shared/configs/modal';
import { useCheckDeskBusyQuery } from '../../../api/desk';

const emptyArr = [];

const CheckDeskBusy = ({ loading = false, children }) => {
  const { props: { id } = {} } = useModalWatch({
    name: modalNames.setDeskName,
  });

  const { data, isFetching } = useCheckDeskBusyQuery({
    params: { deskId: id },
  });

  const acceptanceList = !data || data === 'Error' ? emptyArr : data;

  return (
    <Spin spinning={loading || isFetching}>
      {Boolean(id && acceptanceList.length) && (
        <Alert
          style={{ marginBottom: 16 }}
          message={<AlertMessage acceptanceList={acceptanceList} />}
          type="info"
          showIcon
        />
      )}
      {children}
    </Spin>
  );
};

export default CheckDeskBusy;

const { Paragraph } = Typography;

function AlertMessage({ acceptanceList }) {
  return (
    <Typography>
      <Paragraph>
        Внимание. Стол настроен для следующих приемок:{' '}
        {acceptanceList.map(({ acceptanceName }) => acceptanceName).join(', ')}.
      </Paragraph>
      <Paragraph>
        Если вы измените наименование стола, оно изменится во всех указанных
        приемках.
      </Paragraph>
    </Typography>
  );
}
